import React, { useState } from "react";
import { Button, ProjectCard, Modal } from "../../../components";
import localData from "../../../localData";

export default function Projects() {
    const [isModalShown, setIsModalShown] = useState(false);
    const { angleRight, gameStore, fall, resume } = localData.svgs;

    const projects = [
        {
            title: " business website",
            description:
                "This project is a railway tracking system that allows users to obtain relevant information about train timing.",
            cover: gameStore,
            tools: ["HTML", "CSS", "JavaScript"],
            websiteLink: '#/',
            codeLink: "#/",
            isUpcoming: true,
            isFeatured: true,
        },
        {
            title: "resume-cv pages",
            description:
                "This project is a railway tracking system that allows users to obtain relevant information about train timing.",
            cover: fall,
            tools: ["HTML", "CSS", "JavaScript"],
            websiteLink: 'https://resume-cv-pages.netlify.app/',
            codeLink: "https://github.com/Karen09w/resume-cv",
            isFeatured: true,
        },
        {
            title: " game store template",
            description:
                "This project is a railway tracking system that allows users to obtain relevant information about train timing.",
            cover: resume,
            tools: ["HTML", "CSS", "JavaScript"],
            websiteLink: 'https://game-store-template.netlify.app/',
            codeLink: "https://github.com/Karen09w/gaming-store-js",
            isFeatured: true,
        },
        {
            title: "Railway Tracking 4",
            description:
                "This project is a railway tracking system that allows users to obtain relevant information about train timing.",
            cover: gameStore,
            tools: ["HTML", "CSS", "JavaScript"],
            websiteLink: '',
            codeLink: "",
            isFeatured: false,
        },
    ];

    return (
        <section className="projects" id="projects" data-lazy-block>
            <div className="container-sm">
                <h2 className="projects-title" data-lazy="fade">
                    projects
                </h2>
                <div className="projects-center">
                    {projects.map((project, index) => {
                        if (!project.isFeatured) return;
                        return <ProjectCard key={index} {...project} setIsModalShown={setIsModalShown} />;
                    })}
                </div>
            </div>

            <div className="container-fluid">
                <Button className="link-btn link-btn-warning" isRipple={false} onClick={() => setIsModalShown(true)}>
                    view all
                    <span className="endIcon">{angleRight}</span>
                </Button>
            </div>

            <Modal
                isModalShown={isModalShown}
                setIsModalShown={setIsModalShown}
                dialogClassName="modal-dialog-centered"
                text="under contstruction"
            />
        </section>
    );
}
